import * as React from 'react';
import LocalCafeRoundedIcon from '@mui/icons-material/LocalCafeRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';

// The icon of the product's mark, which a page gives to the shell and to the sign-in page.
// Week 4 had the coffee cup; Week 5 replaced it with the flame, since the cup with the name read as a cafe.
export const CafeMark = <LocalCafeRoundedIcon fontSize="small" />;
export const FlameMark = <LocalFireDepartmentRoundedIcon fontSize="small" />;
